<template>
  <div class='mainContainer'>
    <div class='nav'>
      <el-form :model='searchForm' label-width='110px' :inline='true'>
        <el-form-item label='角色名称：'>
          <el-input v-model='searchForm.roleName' size='mini' placeholder='请输入角色名称' />
        </el-form-item>
        <el-form-item label='状态：'>
          <el-select v-model='searchForm.statusd' filterable size='mini' placeholder='请选择'>
            <el-option v-for='item in statusdOption' :key='item.label' :label='item.label'
                       :value='item.value' />
          </el-select>
        </el-form-item>
      </el-form>
      <div class='navBtn'>
        <el-button size='small' class='searchBtn' @click='searchBtn'>查询</el-button>
        <el-button size='small' class='resetBtn' @click='resetBtn'>重置</el-button>
        <el-button size='small' type='primary' @click='addBtn'>新增</el-button>
      </div>
    </div>
    <div class='content'>
      <el-table
        v-loading='tableLoad'
        :data='tableData'
        style='width: 100%'
        border
        stripe
        :header-cell-style="{color:'#3B3B3B','font-size':'13px','height':'48px',background:'#E8E8E8'}"
        :cell-style="{'color':'#7F7F7F','font-size':'13px','height':'52px',}"
      >
        <el-table-column label='序号' align='center' width='50px' type='index' />
        <el-table-column label='角色名称' prop='roleName' align='center' min-width='250' />
        <el-table-column label='备注' prop='explaind' align='center' min-width='200' />
        <el-table-column label='添加时间' prop='createTime' align='center' min-width='200'>
          <div slot-scope='scope'>{{ scope.row.createTime |timeFormat }}</div>
        </el-table-column>
        <el-table-column label='状态' align='center' width='100'>
          <div slot-scope='scope'>{{ scope.row.statusd |statusFormat }}</div>
        </el-table-column>
        <el-table-column label='操作' min-width='300' align='center'>
          <template slot-scope='scope'>
            <el-button v-if='scope.row.statusd' size='mini' type='danger'
                       @click='enableOrDisable(scope.row.id,"disable")'>禁用
            </el-button>
            <el-button v-else size='mini' type='primary'
                       @click='enableOrDisable(scope.row.id,"enable")'>启用
            </el-button>
            <el-button size='mini' type='primary' @click='changeClick(scope.row)'
                       class='yellow-bg'>修改
            </el-button>
            <el-button size='mini' type='primary' @click='setClick(scope.row)' class='resetBtn'>
              权限设置
            </el-button>
            <el-button size='mini' type='danger' class='delete'
                       @click='deleteClick(scope.row.id)'>删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class='paginationContainer'>
        <span>共{{ total }}条</span>
        <el-pagination
          background
          :page-sizes='[10, 20, 30, 40]'
          layout='sizes,prev, pager, next,jumper'
          :total='total'
          @size-change='contractSizeChange'
          @current-change='contractCurrentChange'
          @prev-click='contractCurrentChange'
          @next-click='contractCurrentChange'
        />
      </div>
    </div>

    <!-- 新增/修改 -->
    <app-role-new ref='appRoleNewRef' @success='getList' />
    <!-- 权限设置 -->
    <app-role-permission-settings ref='appRolePermissionSettingRef' @success='getList' />
  </div>
</template>

<script>
  import { formatDateTime } from '@/config/mUtils';
  import {
    appRolePageList,
    isEnableAppRole,
    deleteAppRole,
  } from '@/service/basicfile';
  import AppRoleNew from '@/views/basicfile/system/app-role-components/app-role-new';
  import AppRolePermissionSettings
    from '@/views/basicfile/system/app-role-components/app-role-permission-settings';

  export default {
    components: {
      AppRolePermissionSettings,
      AppRoleNew,
    },
    data() {
      return {
        defaultSearchForm: {},
        searchForm: {
          roleNm: '',
          statusd: '',
          rows: 10,
          page: 1,
        },
        statusdOption: [
          {
            value: '',
            label: '全部',
          },
          {
            value: 1,
            label: '启动中',
          },
          {
            value: 0,
            label: '禁用中',
          },
        ],
        tableLoad: false,
        tableData: [],
        total: 0,
      };
    },
    mounted() {
      this.defaultSearchForm = JSON.parse(JSON.stringify(this.searchForm));
      this.getList();
    },
    filters: {
      timeFormat(val) {
        return formatDateTime(val, 'yyyy-mm-dd hh:ii:ss');
      },
      statusFormat(status) {
        switch (status) {
          case 1:
            return '启用中';
          case 0:
            return '禁用中';
        }
      },
    },
    methods: {
      // 分页查询
      async getList() {
        this.tableLoad = true;
        const res = await appRolePageList(this.searchForm);
        this.tableLoad = false;
        if (res.status !== 0) return this.$message.error(res.message);
        this.tableData = res.data.records;
        this.total = res.data.totalRows;
      },
      resetBtn() {
        this.searchForm = JSON.parse(JSON.stringify(this.defaultSearchForm));
      },
      searchBtn() {
        this.searchForm.page = 1;
        this.getList();
      },
      // 改变当前页数据条数
      contractSizeChange(sizes) {
        this.searchForm.rows = sizes;
        this.getList();
      },
      // 切换当前页
      contractCurrentChange(page) {
        this.searchForm.page = page;
        this.getList();
      },
      // 启用/禁用
      enableOrDisable(id, flag) {
        this.$confirm(flag === 'disable' ? '确定要禁用当前角色吗？' : '确定要启用当前角色吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(async () => {
            const res = await isEnableAppRole({ id });
            if (res.status !== 0) return this.$message.error(res.message);
            this.$message.success(res.message);
            await this.getList();
          })
          .catch(() => {
          });
      },
      // 删除
      deleteClick(id) {
        this.$confirm('确定要删除当前角色吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(async () => {
            const res = await deleteAppRole({ id });
            if (res.status !== 0) return this.$message.error(res.message);
            this.$message.success(res.message);
            await this.getList();
          })
          .catch(() => {
          });
      },
      // 权限设置
      setClick(item) {
        this.$refs.appRolePermissionSettingRef.dialogOpen(item);
      },
      addBtn() {
        this.$refs.appRoleNewRef.dialogOpen('新增角色');
      },
      changeClick(item) {
        this.$refs.appRoleNewRef.dialogOpen('修改角色', item);
      },
    },
  };
</script>


<style lang='scss' scoped>
  .mainContainer {
    width: 100%;
    padding: 20px 15px 0 15px;
    background-color: #fff;

    .nav {
      width: 100%;
      display: flex;
      align-items: center;
      flex-wrap: wrap;

      &Container {
        width: 200px;
        display: flex;
        align-items: center;
        margin-right: 5px;
        margin-bottom: 5px;

        p {
          font-size: 14px;
          color: rgba(16, 16, 16, 100);
        }
      }

      &Btn {
        display: flex;
        align-items: center;
        margin-bottom: 5px;
      }
    }

    .content {
      .paginationContainer {
        margin-right: auto;
        display: flex;
        align-items: center;
        margin-top: 10px;

        span {
          font-size: 13px;
        }
      }
    }
  }
</style>
